import {
  MedicineBoxOutlined,
  CalendarOutlined,
  UserSwitchOutlined,
  FileTextOutlined,
  StarOutlined,
  GoldOutlined,
  DollarOutlined,
  UserAddOutlined,
  ApartmentOutlined
} from '@ant-design/icons';

const consultation = {
  id: 'group-consultation',
  title: 'Consultation Management',
  type: 'group',
  children: [
    {
      id: 'consultation-collapse',
      title: 'Consultation',
      type: 'collapse',
      icon: MedicineBoxOutlined,
      children: [
        { id: 'consultation-category', title: 'Category', type: 'item', url: '/consultation/category', icon: ApartmentOutlined },
        { id: 'instant-consultation', title: 'Instant Consultation', type: 'item', url: '/consultation/instant-consultation', icon: FileTextOutlined },
        { id: 'longterm-consultation', title: 'Longterm Consultation', type: 'item', url: '/consultation/lognterm-consultation', icon: FileTextOutlined },
        // { id: 'consultation-appointments', title: 'Appointments', type: 'item', url: '/consultation/appointments', icon: CalendarOutlined },
        // { id: 'consultation-nutritionists', title: 'Nutritionists', type: 'item', url: '/consultation/nutritionists', icon: UserSwitchOutlined },
        // { id: 'consultation-reviews', title: 'Reviews & Ratings', type: 'item', url: '/consultation/reviews', icon: StarOutlined },
        // { id: 'consultation-billing', title: 'Billing', type: 'item', url: '/consultation/billing', icon: DollarOutlined }
      ]
    },
    {
      id: 'coach-collapse',
      title: 'Coach',
      type: 'collapse',
      icon: UserAddOutlined,
      children: [
        { id: 'tier', title: 'Tier', type: 'item', url: '/coach/tier', icon: GoldOutlined },
        { id: 'coaches', title: 'Coaches', type: 'item', url: '/coach/coaches', icon: UserAddOutlined },
      ]
    }
  ]
};

export default consultation;
